import Login from "../views/Account/Login.vue";
import ResetPassword from "../views/Account/ResetPassword.vue";
import Profile from "../views/Account/Profile.vue";
import ForgotPassword from "../views/Account/ForgotPassword.vue";

const accountRoutes = [
     {
          path: "/Login",
          name: "Login",
          component: Login,
     },

     {
          path: "/Profile",
          name: "Profile",
          component: Profile,
          meta: { requiresAuth: true },
     },

     {
          path: "/ResetPassword/:type/:email?",
          name: "ResetPassword",
          component: ResetPassword,
          props: true,
     },

     {
          path: "/ForgotPassword",
          name: "ForgotPassword",
          component: ForgotPassword,
     },
];

export default accountRoutes;
